import React, { useLayoutEffect, useMemo } from 'react'
import { usePortal } from '../hooks/usePortal'
import { useAxios } from '../hooks/useAxios'
import NotFound from '../components/NotFound'
import Breadcrumbs from '../components/Breadcrumbs'
import { createPortal } from 'react-dom'
import { useNavigate, useParams } from 'react-router'
import getArticle from '../api/getArticle'
import Skeleton from 'react-loading-skeleton'
import { IQuest, IQuestItem } from '../server/quests'
import { useForm } from 'react-hook-form'
import { cloneDeep } from 'lodash-es'
import { updateQuest } from '../api/updateQuest'
import { toast } from 'react-toastify'
import {QuestForm} from "../components/QuestControls/QuestForm";

const BREADCRUMBS = [
  {
    label: 'Главная',
    path: '/'
  },
  {
    label: 'Опросы',
    path: '/quests'
  }
]

export const QuestPage = () => {
  const { portal } = usePortal()
  const { response, fire, error, loading } = useAxios()
  const submit = useAxios()
  const { id } = useParams()
  const navigate = useNavigate()

  const breadcrumbs = useMemo(() => {
    if (response?.data?.title) {
      return BREADCRUMBS.concat({
        label: response.data.title,
        path: `/quests/${response.data.id}`
      })
    }

    return BREADCRUMBS.concat({
      label: '',
      path: ''
    })
  }, [response])

  const {
    control,
    setValue,
    handleSubmit,
    formState: { errors, isSubmitted, isValid }
  } = useForm({
    mode: 'onSubmit'
  })

  useLayoutEffect(() => {
    response?.data?.items.forEach((item: IQuestItem) => {
      setValue(item.name, item.value)
    })
  }, [response?.data])

  useLayoutEffect(() => {
    fire(getArticle('/quests/item', id ?? ''))
  }, [])

  const onSubmit = async (data: any) => {
    const _response = cloneDeep<IQuest>(response?.data as IQuest)

    _response?.items.forEach((item: IQuestItem) => {
      item.value = data[item.name]
    })

    try {
      await submit.fire(updateQuest(id as string, _response))

      toast.success('Результаты успешно отправлены')
      navigate('/quests')
    } catch (e: any) {
      toast.error(e.message)
    }
  }

  if (error?.response?.status === 404) {
    return (
      <div className={'page'}>
        <NotFound />
      </div>
    )
  }

  return (
    <div className={'page'}>
      <Breadcrumbs className={'page__breadcrumbs'} breadcrumbs={breadcrumbs} />
      {portal &&
        createPortal(
          <Breadcrumbs breadcrumbs={breadcrumbs}></Breadcrumbs>,
          portal
        )}

      {error ? (
        <div className={'page__content'}>{error?.message}</div>
      ) : (
        <>
          {loading ? (
            <>
              <div>
                <Skeleton width="50%" height="5rem" />

                <div className={'mt-lg-10 mt-md-10 mt-sm-8'}>
                  {Array.from({ length: 3 }).map((_, index) => (
                    <Skeleton
                      width={index < 2 ? '100%' : '75%'}
                      height="1.8rem"
                      key={index}
                    />
                  ))}
                </div>
              </div>

              <div className={'page__content'}>
                <div className={'app-grid'}>
                  {Array.from({ length: 6 }).map((_, index) => (
                    <Skeleton
                      width={'100%'}
                      height="17.6rem"
                      borderRadius={'3.2rem'}
                      key={index}
                    />
                  ))}
                </div>
              </div>
            </>
          ) : response?.data ? (
            <>
              <div className={'page__head'}>
                <div>
                  <h1>{response.data.title}</h1>

                  {response.data.description && (
                    <p className={'mt-lg-10 mt-md-10 mt-sm-8'}>
                      {response.data.description}
                    </p>
                  )}
                </div>
              </div>

              {response?.data?.items && response.data.items.length > 0 && (
                  <QuestForm
                      quest={response.data as IQuest}
                      onSubmit={onSubmit}
                      isSubmitting={false}
                      isActive={response?.data?.isActive}
                  />
              )}
            </>
          ) : (
            <div className={'page__content'}>{'Нет данных'}</div>
          )}
        </>
      )}
    </div>
  )
}
